/**
 * @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
 * @license AGPL-3.0
 *
 * This code is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.
 *
 * Any use of the work other than as authorized under this license or copyright law is prohibited.
 */

import $ from '@/jquery'
import api from '@/io.ox/mail/categories/api'
import mailApi from '@/io.ox/mail/api'
import folderApi from '@/io.ox/core/folder/api'
import Dropdown from '@/io.ox/backbone/mini-views/dropdown'
import * as actionsUtil from '@/io.ox/backbone/views/actions/util'
import yell from '@/io.ox/core/yell'
import { createIcon } from '@/io.ox/core/components'
import { settings as mailSettings } from '@/io.ox/mail/settings'
import gt from 'gettext'

const PickerDropdown = Dropdown.extend({

  tagName: 'li',

  renderMenu ({ folderId = '', props = {}, data = [] } = {}) {
    this.$ul.empty()
    this.folderId = folderId
    this.props = props
    this.data = [].concat(data)
    this.addCategories()
    this.addFolders()
    this.addLinks()
  },

  addCategories () {
    const current = this.props.get('category_id')
    const list = api.collection.filter(model => model.isEnabled() && model.id !== current)
    if (!list.length) return

    this.header(gt('Move to category'))
    list.forEach(model => {
      const name = model.get('name')
      const icon = model.get('icon')
      this.link(model.id, name, $.proxy(this.onCategory, this, this.data), { icon: createIcon(`bi/${icon}.svg`).addClass('me-8') })
    })
    this.divider()
  },

  addFolders () {
    const ids = mailSettings.get('lastTargetFolderIds', [])
      .filter(id => id !== this.folderId)
    if (!ids.length) return
    this.header(gt('Recent target folders'))
    ids.forEach(targetFolderId => {
      const textNode = folderApi.getTextNode(targetFolderId)
      this.link(`move-to-${targetFolderId}`, () => textNode, () => mailApi.move(this.data, targetFolderId))
    })
    this.divider()
  },

  addLinks () {
    this.link('move-to-folder', gt('Move to folder') + ' …', $.proxy(this.onLink, this, this.data))
  },

  onCategory (data, e) {
    const node = $(e.currentTarget)
    const category = node.attr('data-name') || '0'
    const name = node.text()
    const source = this.props.get('category_id')

    api.move({
      data,
      source,
      sourcename: api.collection.get(source).get('name'),
      target: category,
      targetname: name
    }).fail(yell)
  },

  onLink (data) {
    // Tested: false
    actionsUtil.invoke('io.ox/mail/actions/move', data)
  }
})

mailApi.on('move', (e, list, targetFolderId) => {
  if (!targetFolderId) return
  let ids = mailSettings.get('lastTargetFolderIds', [])
  ids = [targetFolderId, ...ids.filter(id => id !== targetFolderId)].slice(0, 5)
  mailSettings.set('lastTargetFolderIds', ids).save()
})

const picker = {
  appendDropdown (node, options) {
    node.addClass('dropdown-toggle')
    node.parent().addClass('dropdown categories')

    new PickerDropdown({
      el: node.parent(),
      $toggle: node
    }).render().renderMenu(options)
  },
  attach (node, options) {
    this.appendDropdown(node, options)
  }
}

export default picker
